<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑自提点' : '添加自提点'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm"  :model="item" label-width="auto">
			<!--            有id时候 静态页面数据-->

			<el-form-item label="自提点名称">
				<el-input v-model="item.title" placeholder="请输入自提点名称"></el-input>
			</el-form-item>
			<el-form-item label="联系人">
				<el-input v-model="item.name" placeholder="请输入联系人"></el-input>
			</el-form-item>
			<el-form-item label="手机号码">
				<el-input v-model="item.mobile" placeholder="请输入手机号码"></el-input>
			</el-form-item>
			<el-form-item label="地址">
				<el-input v-model="item.address" placeholder="请输入地址"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				rules:{}
			}
		},
		created() {
			if (this.id) {
				this.loadData()
			}
		},
		methods: {
			loadData: function() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/admin/setting/pick',{
					params:{
						id: this.id
					}
				}).then(res => {
					this.isLoad = !this.isLoad
					this.item = res.data
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let url = ''
				if (this.id) {
					url = '/admin/setting/pickEdit'
					this.item.id = this.id
				} else {
					url = '/admin/setting/pickAdd'
				}
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
